module.exports = __webpack_public_path__ + "img/physicalIco.f3080ce9.svg";